<ng-template #tplCard>
  <ion-item lines="full" color="light">
    <ion-icon size="large" slot="start" name="laptop-outline" color="primary"></ion-icon>
    <ion-label>
      Office Meters Monitor
    </ion-label>
    <ion-button *ngIf="!checkIfToday()" (click)="exportToMeterCsv()" slot="end">
      <ion-icon name="receipt-outline" translate>Edge.History.export</ion-icon>
    </ion-button>
  </ion-item>

  <!-- Skeleton Loader -->
  <ion-list *ngIf="loading" lines="full" [inset]="true">
    <ion-list-header>
      <ion-skeleton-text *ngFor="let width of skeletonHeaderWidths" animated [style.width]="width"></ion-skeleton-text>
    </ion-list-header>
    <ion-item *ngFor="let i of fakeItems">
      <ion-skeleton-text *ngFor="let width of skeletonItemWidths" animated [style.width]="width"></ion-skeleton-text>
    </ion-item>
  </ion-list>

  <!-- Actual Data List -->
  <ion-list *ngIf="!loading" lines="full" [inset]="true">
    <ion-list-header>
      <ion-label>Meter Name</ion-label>
      <ion-label>{{'GENERAL.CONSUMPTION'|translate}} /kWh</ion-label>
      <ion-label>{{'GENERAL.PRODUCTION'|translate}} /kWh</ion-label>
    </ion-list-header>
    <ion-item *ngFor="let meter of meters; let i = index">
      <ion-label>{{meter.alias}}</ion-label>
      <ion-label>{{ getConsumptionData(i).toFixed(0) }} </ion-label>
      <ion-label>{{ getProductionData(i).toFixed(0) }} </ion-label>
    </ion-item>
  </ion-list>

</ng-template>

<div class="ion-hide-sm-down">
  <ion-card class="ion-no-padding">
    <ng-template *ngTemplateOutlet="tplCard"></ng-template>
  </ion-card>
</div>

<div class="ion-hide-sm-up">
  <ion-card class="ion-no-padding" style="box-shadow: none !important">
    <ng-template *ngTemplateOutlet="tplCard"></ng-template>
  </ion-card>
</div>
